import {runOnPage} from './general.js';
import flatpickr from 'flatpickr';
import cs from 'flatpickr/dist/l10n/cs';
import en from 'flatpickr/dist/l10n/default';
import 'flatpickr/dist/flatpickr.min.css';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

runOnPage('career-detail', () => {
	$(function () {
		const lang = document.documentElement.lang || 'en';
		const localeMap = {cs: cs.default, en: en.default};
		flatpickr('.datepicker', {locale: localeMap[lang]});


		function toggleActiveSourceButtons(value) {
			$('input[name="source"]').each(function () {
				$(this).closest('label')
					.removeClass('bg-deepvision-600 text-deepvision-100');
			});
			$(`input[name="source"][value="${value}"]`).each(function () {
				$(this).closest('label')
					.addClass('bg-deepvision-600 text-deepvision-100');
			});
		}


		$('input[name="source"]').on('change', function () {
			toggleActiveSourceButtons($(this).val());
		});
		toggleActiveSourceButtons($('input[name="source"]:checked').val());

		$('.custom-file-input').on('change', function () {
			const $input = $(this);
			const file = this.files[0];
			const inputId = $input.attr('id');
			const $label = $(`label[for="${inputId}"]`);
			const $textSpan = $label.find('.custom-file-button-text');
			const defaultTxt = $textSpan.data('default') || 'Choose file';

			if (file) {
				$textSpan.text(file.name).attr('title', file.name);
			}
			else {
				$textSpan.text(defaultTxt).removeAttr('title');
			}
		});

		const sideNav = document.getElementById('careerSideNav');
		const whiteSection = document.getElementById('career-section');
		if (sideNav && whiteSection) {
			function updateNavPosition() {
				const navHeight = sideNav.offsetHeight;
				const sectionTop = whiteSection.offsetTop;
				const sectionHeight = whiteSection.offsetHeight;
				const sectionBottom = sectionTop + sectionHeight;

				const scrollY = window.scrollY;
				const fixedTop = (window.innerHeight - navHeight) / 2;
				const idealNavY = scrollY + fixedTop;

				const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
				const minLeft = 1 * rem;
				const maxLeft = 150 * rem;
				let computedLeft = (window.innerWidth - 800) / 2 - 380;
				computedLeft = Math.max(minLeft, Math.min(computedLeft, maxLeft));

				if (idealNavY <= sectionTop) {
					sideNav.style.position = 'absolute';
					sideNav.style.top = '0px';
					const whiteLeft = whiteSection.getBoundingClientRect().left;
					sideNav.style.left = `${computedLeft - whiteLeft}px`;

				}
				else if (idealNavY + navHeight >= sectionBottom) {
					sideNav.style.position = 'absolute';
					sideNav.style.top = `${sectionHeight - navHeight}px`;
					const whiteLeft = whiteSection.getBoundingClientRect().left;
					sideNav.style.left = `${computedLeft - whiteLeft}px`;

				}
				else {
					sideNav.style.position = 'fixed';
					sideNav.style.top = `${fixedTop}px`;
					sideNav.style.left = `${computedLeft}px`;
				}
			}


			window.addEventListener('scroll', () => requestAnimationFrame(updateNavPosition));
			window.addEventListener('resize', updateNavPosition);
			updateNavPosition();
		}
	});
});

runOnPage('career-default', () => {
	// SCROLL SECTION
	function initCareerScroll() {
		const wrapper = document.querySelector('.career-pinned-wrapper');
		const container = wrapper ? wrapper.querySelector('.career-scroll') : null;
		const scroller = wrapper ? wrapper.querySelector('.career-inner') : null;
		if (!wrapper || !container || !scroller) {
			return;
		}

		let maxScroll = scroller.scrollHeight - container.clientHeight;
		if (maxScroll <= 0) {
			return;
		}

		ScrollTrigger.getAll().forEach(t => {
			if (t.vars.pin === wrapper) {
				t.kill();
			}
		});

		gsap.timeline({
			scrollTrigger: {
				trigger:             wrapper,
				start:               'top top',
				end:                 () => `+=${maxScroll}`,
				scrub:               true,
				pin:                 wrapper,
				invalidateOnRefresh: true
			}
		}).to(scroller, {
			y:    () => -maxScroll,
			ease: 'none'
		});
	}

	window.addEventListener('load', () => {
		initCareerScroll();
		ScrollTrigger.refresh();
	});
	window.addEventListener('resize', () => {
		initCareerScroll();
		ScrollTrigger.refresh();
	});

	// MODAL VIDEO
	$(function() {
		var $link     = $('#watch-video-link');
		var $modal    = $('#video-modal');
		var $closeBtn = $('#close-video-modal');
		var $video    = $('#modal-video');

		$link.on('click', function(e) {
			e.preventDefault();

			$video.attr('src', $(this).attr('href'));

			$modal.removeClass('hidden').addClass('flex');
			$video[0].currentTime = 0;
			$video[0].play();
			$('body, html').css('overflow', 'hidden');
			$('.hide-on-video-modal').addClass('hidden');
		});

		$closeBtn.on('click', function() {
			$modal.addClass('hidden').removeClass('flex');
			$video[0].pause();
			$video[0].currentTime = 0;

			$video.attr('src', '');

			$('body, html').css('overflow', '');
			$('.hide-on-video-modal').removeClass('hidden');
		});
	});
});
